import noop from 'lodash/noop'

import type { ListenerType } from './types'

class Uploader {
  xhr: XMLHttpRequest

  constructor() {
    this.xhr = new XMLHttpRequest()
  }

  /**
   *
   * @param {array} listeners format: {name: <name of event>, fn: callback function }.
   */
  setListener(listeners?: ListenerType[]) {
    if (typeof listeners === 'undefined' || !Array.isArray(listeners)) {
      return
    }
    for (const i in listeners) {
      if (typeof listeners[i].name === 'undefined' || typeof listeners[i].fn === 'undefined') {
        continue
      }
      this.xhr.upload.addEventListener(listeners[i].name, listeners[i].fn)
    }
  }
  /**
   *
   * @param {array} listeners format: {name: <name of event>, fn: callback function }.
   */
  removeListener(listeners?: ListenerType[]) {
    if (typeof listeners === 'undefined' || !Array.isArray(listeners)) {
      return
    }
    for (const i in listeners) {
      if (typeof listeners[i].name === 'undefined' || typeof listeners[i].fn === 'undefined') {
        continue
      }
      this.xhr.upload.removeEventListener(listeners[i].name, listeners[i].fn)
    }
  }

  setTimeout(timeout: number) {
    this.xhr.timeout = timeout
  }

  /**
   *
   * @param {string} url
   * @param {string} method
   * @param {Object} payload
   * @param {Function} [success] optional.
   * @param {Function} [failure] optional.
   */
  send(
    url: string,
    method: string,
    payload: Document | XMLHttpRequestBodyInit | null | undefined,
    success?: (response: any) => void,
    failure?: (status: number) => void
  ) {
    const successFunction = success || noop
    const failFunction = failure || noop

    this.xhr.onreadystatechange = () => {
      if (this.xhr.readyState === 4) {
        if (this.xhr.status === 200) {
          successFunction(this.xhr.response)
        } else {
          failFunction(this.xhr.status)
        }
      }
    }
    this.xhr.open(method, url, true)
    this.xhr.send(payload)
  }

  abort() {
    this.xhr.abort()
  }
}

export { Uploader }
